import React from 'react'
import cn from 'classnames'
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver'
import ColorPicker from './ColorPicker'
import './index.less'

export default function (props) {
  return (
    <LocaleReceiver componentName="ColorPicker">
      {(locale) => {
        return <ColorPicker locale={locale} {...props} />
      }}
    </LocaleReceiver>
  )
}
